goog.provide('el8.data.ancillaryCompanies');

goog.require('el8.model.base');
goog.require('el8.util.string');

el8.data.ancillaryCompanies.lab = (function() {

    /**
     * Ancillary companies that have a lab center
     * - For now, since we only have these sorts of ancillary companies on the client,
     *   I've punted on what we should do once we have multiple sorts (i.e. imaging, cardiac, 
     *   etc.).  At that point we probably want flags like "isLab" "isImaging", etc.
     *
     * BiDiLabs: deprecate after transition. also used in settngs...
     */

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('nickname');
    _class.addBoolean('hasTestCompendium');

    _class.prototype.isHasOrderCompendium = function() {
        // Forward compatibility with new bidi labs stuff
        return this.isHasTestCompendium();
    };


    _class.prototype.getDisplayName = function() {
        return this.getNickname() || this.getName();
    };

    _class.prototype.asSoyMap = function() {
        return {
            id: this.getId(),
            name: this.getDisplayName()
        };
    };

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() {
            return el8.service.urls.get('labAncillaryCompanies');
        },
        sortFn: function(a, b) {
            return el8.util.string.cmp(a.getDisplayName(), b.getDisplayName());
        }
    });

})();

